module.exports = __webpack_public_path__ + "media/images/disbursement_channels/payoo-0798c22654a5b9b52d5a825ba3f77d89.svg";